import { Heart } from 'lucide-react';

import { clsx } from 'clsx';

import { addToFavoriteThunk, removeFromFavoritesThunk } from '@screens/Favorites';
import { ACCENT } from '@shared/constants/colors';
import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { Metrics } from '@shared/types/enums/metrics.enum';
import { Tooltip } from '@shared/ui/Tooltip';
import { getProductCardData } from '@shared/utils/getProductCardData/getProductCardData';
import { sendMetrics } from '@shared/utils/sendMetrics/sendMetrics';

import cls from './FavoriteButton.module.scss';

export const FavoriteButton = () => {
  const product = useAppSelector((state) => state.product.data);

  const favoriteProducts = useAppSelector((state) => state.favorites.productIds);
  const isFavorite =
    favoriteProducts && favoriteProducts.length ? favoriteProducts.find((el) => el === product.id) : false;

  const dispatch = useAppDispatch();

  const toggleFavorite = () => {
    if (isFavorite) {
      dispatch(removeFromFavoritesThunk(product.id));
    } else {
      const result = getProductCardData({
        [product.id]: product
      });
      dispatch(addToFavoriteThunk(result[0].id));
      sendMetrics(Metrics.LIKE_GOAL);
    }
  };

  return (
    <Tooltip label={isFavorite ? 'Убрать из избранного' : 'Добавить в избранное'}>
      <button
        aria-label={isFavorite ? 'Убрать из избранного' : 'Добавить в избранное'}
        onClick={toggleFavorite}
        className={clsx(cls.icon, { [cls.favorite]: isFavorite })}
      >
        <Heart
          size={20}
          color={ACCENT}
        ></Heart>
      </button>
    </Tooltip>
  );
};
